import { gql } from "@/__generated__/gql";

export const CURRENT_COHORT_YEAR = gql(`
  query CurrentCohortYear {
    currentCohortYear
  }
`);
